

export const compressionOptions = {
  maxWidthOrHeight: 1600, // in pixels
  maxSizeMB: 0.75, // Target ~750KB file size
  quality: 0.95, // Max= 1.0 (100%)
  useWebWorker: true, // Optimize processing / multithread
};

